const keys = new Set([
  'APP_ENV',
  'PUSHER_KEY',
  'PUSHER_CLUSTER',
  'JIMINNY_HOST',
  'JIMINNY_HOST_EU',
  'GOOGLE_CLIENT_ID',
  'OFFICE_CLIENT_ID',
  'GOOGLE_ANALYTICS_ID',
  'SENTRY_DSN',
  'RELEASE',
  'EXTENSION_ID',
  'LOGROCKET_ID'
])

const ENV = new Map()

keys.forEach(key => ENV.set(key, process.env[key]))

export default function env (key) {
  if (!ENV.has(key)) {
    console.warn(`[env]: Unknown key ${key}`)
  }

  return ENV.get(key)
}



// WEBPACK FOOTER //
// ./src/lib/env.js